// extracted by mini-css-extract-plugin
module.exports = {"color-storm-grey":"#6D7288","colorStormGrey":"#6D7288","body-text":"_2oczQ","bodyText":"_2oczQ","from":"_2MBcX _2oczQ"};